import React, { useContext, useRef, useState } from "react";
import { Button } from "@windmill/react-ui";

// internal import
import { SidebarContext } from "context/SidebarContext";
import spinnerLoadingImage from "assets/img/spinner.gif";
import ConfirmModal from "../../components/modal/ConfirmationModal";

const DrawerButton = ({ title, isSubmitting, Action,allotname }) => {
  const { toggleDrawer, isDrawerOpen } = useContext(SidebarContext);

  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const formRef = useRef(null);

  const isModify = Action === "modify";
 
  // Update / Assign button
  const handleSubmitClick = (e) => {
    // Only Modify requires confirmation
    if (isModify) {
      e.preventDefault();
      e.stopPropagation();

      // Store the parent form
      formRef.current = e.currentTarget.closest("form");

      // Open confirmation modal
      setShowConfirmModal(true);

      return;
    }

    // Assign mode:
    // type="submit" will submit the existing form normally.
  };

  // Yes, Update
  const handleConfirm = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const form = formRef.current;

    // Close confirmation modal
    setShowConfirmModal(false);

    // Submit the original parent form
    if (form) {
      form.requestSubmit();
    }
  };

  // No
  const handleCancel = (e) => {
    e.preventDefault();
    e.stopPropagation();

    // Close modal only
    setShowConfirmModal(false);

    // Clear stored form
    formRef.current = null;
  };

  return (
    <>
      <div
        className="fixed z-10 bottom-0 w-full right-0 py-4 px-3 grid gap-4 lg:gap-6 xl:gap-6 md:flex xl:flex bg-gray-50 border-t border-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300"
        style={{ right: !isDrawerOpen && -50 }}
      >
        {/* Cancel */}
        <div className="flex-grow-0 md:flex-grow lg:flex-grow xl:flex-grow">
          <Button
            type="button"
            onClick={toggleDrawer}
            style={{ height: "40px" }}
            className="bg-white w-full text-red-500 hover:bg-red-50 hover:border-red-100 hover:text-red-600 dark:bg-gray-700 dark:border-gray-700 dark:text-gray-500 dark:hover:bg-gray-800 dark:hover:text-red-700"
            layout="outline"
          >
            Cancel
          </Button>
        </div>

        {/* Assign / Update */}
        <div className="flex-grow-0 md:flex-grow lg:flex-grow xl:flex-grow">
          {isSubmitting ? (
            <Button  type="button" className="w-full h-10">
              <img
                src={spinnerLoadingImage}
                alt="Loading"
                width={20}
                height={10}
              />

              <span className="font-serif ml-2 font-light">Processing</span>
            </Button>
          ) : (
            <Button
              type={isModify ? "button" : "submit"}
              disabled={ isSubmitting}
              onClick={handleSubmitClick}
              className="w-full h-10"
            >
              <span>{title || "Save"}</span>
            </Button>
          )}
        </div>
      </div>

      {/* Confirmation Modal */}
      <ConfirmModal
        isOpen={showConfirmModal}
        title="Confirm Update"
        message={`Are you sure you want to update this ${allotname}`}
        onCancel={handleCancel}
        onConfirm={handleConfirm}
        confirmText="Yes, Update"
        cancelText="No"
        loading={isSubmitting}
      />
    </>
  );
};

export default DrawerButton;
